import { useEffect, useState } from "react";
import { vpAxios, money, VAIPEDE_API, downloadPdf } from "../api";
import { toast } from "sonner";
import { Plus, Minus, Trash2, Search, ClipboardList, Printer, X, CreditCard, Wifi, Eye } from "lucide-react";

const TIPOS = [
  { key: "balcao", label: "Balcão" },
  { key: "mesa", label: "Mesa" },
  { key: "delivery", label: "Delivery" },
];

export default function PdvPage() {
  const [produtos, setProdutos] = useState([]);
  const [mesas, setMesas] = useState([]);
  const [busca, setBusca] = useState("");
  const [carrinho, setCarrinho] = useState([]);
  const [tipo, setTipo] = useState("balcao");
  const [mesaId, setMesaId] = useState("");
  const [cliente, setCliente] = useState({ nome: "", whatsapp: "", endereco: "" });
  const [obs, setObs] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPagto, setShowPagto] = useState(false);
  const [showComandas, setShowComandas] = useState(false);

  useEffect(() => {
    vpAxios.get("/vaipede/produtos").then(r => setProdutos(r.data));
    vpAxios.get("/vaipede/mesas").then(r => setMesas(r.data));
  }, []);

  const filtrados = produtos.filter(p => p.ativo !== false && p.nome.toLowerCase().includes(busca.toLowerCase()));

  const add = (p) => setCarrinho(c => {
    const ex = c.find(x => x.produto_id === p.id);
    if (ex) return c.map(x => x.produto_id === p.id ? { ...x, quantidade: x.quantidade + 1 } : x);
    return [...c, { produto_id: p.id, nome: p.nome, categoria: p.categoria, foto_url: p.foto_url, preco: p.preco, quantidade: 1 }];
  });
  const dec = (id) => setCarrinho(c => c.map(x => x.produto_id === id ? { ...x, quantidade: Math.max(0, x.quantidade - 1) } : x).filter(x => x.quantidade > 0));
  const rem = (id) => setCarrinho(c => c.filter(x => x.produto_id !== id));

  const total = carrinho.reduce((s, x) => s + x.preco * x.quantidade, 0);

  const criarPedido = async (statusFinal, forma, extra = {}) => {
    if (!carrinho.length) { toast.error("Adicione ao menos 1 item"); return null; }
    if (tipo === "mesa" && !mesaId) { toast.error("Selecione a mesa"); return null; }
    setLoading(true);
    try {
      const mesa = mesas.find(m => m.id === mesaId);
      const payload = {
        tipo, origem: "pdv",
        mesa_id: tipo === "mesa" ? mesaId : null,
        mesa_numero: tipo === "mesa" ? mesa?.numero : null,
        cliente_nome: cliente.nome, cliente_whatsapp: cliente.whatsapp,
        endereco: cliente.endereco, itens: carrinho,
        forma_pagamento: forma, observacao: obs, status: statusFinal,
        ...extra,
      };
      const { data } = await vpAxios.post("/vaipede/pedidos", payload);
      toast.success(`Pedido #${data.numero} criado!`);
      return data;
    } catch (e) { toast.error(e?.response?.data?.detail || "Erro"); return null; }
    finally { setLoading(false); }
  };

  const enviarCozinha = async () => {
    const p = await criarPedido("preparando", "");
    if (p) {
      setCarrinho([]); setObs("");
      // Auto-abre o PDF do pedido para impressão (mesmo helper do "Baixar")
      downloadPdf(`/vaipede/pedidos/${p.id}/recibo-termico`, `pedido-${p.numero}.pdf`)
        .catch(() => {});
    }
  };

  const abrirConfirmarPagto = () => {
    if (!carrinho.length) return toast.error("Adicione ao menos 1 item");
    setShowPagto(true);
  };

  return (
    <div data-testid="vaipede-pdv">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h1 className="text-2xl font-black">Novo pedido</h1>
          <p className="text-sm text-neutral-500">Balcão · Mesa · Delivery</p>
        </div>
        <button onClick={() => setShowComandas(true)} className="px-4 py-2.5 rounded-xl bg-white border border-neutral-200 font-bold text-sm flex items-center gap-2" data-testid="vaipede-btn-comandas-dia">
          <ClipboardList className="w-4 h-4"/> Comandas do dia
        </button>
      </div>

      <div className="flex flex-wrap gap-2 mb-4">
        {TIPOS.map(t => (
          <button key={t.key} onClick={() => setTipo(t.key)} className={`px-4 py-2 rounded-full font-bold text-sm ${tipo === t.key ? "bg-[#EA1D2C] text-white" : "bg-white border border-neutral-200 text-neutral-700"}`} data-testid={`vaipede-tipo-${t.key}`}>
            {t.label}
          </button>
        ))}
      </div>

      <div className="bg-white rounded-2xl border border-neutral-200 p-4 mb-4">
        <div className="grid md:grid-cols-3 gap-3">
          {tipo === "mesa" && (
            <select value={mesaId} onChange={e => setMesaId(e.target.value)} className="px-3 py-2.5 rounded-xl border border-neutral-200 text-sm" data-testid="vaipede-select-mesa">
              <option value="">Selecione a mesa</option>
              {mesas.map(m => <option key={m.id} value={m.id}>Mesa {m.numero}</option>)}
            </select>
          )}
          <input value={cliente.nome} onChange={e => setCliente({...cliente, nome: e.target.value})} placeholder="Nome do cliente" className="px-3 py-2.5 rounded-xl border border-neutral-200 text-sm"/>
          <input value={cliente.whatsapp} onChange={e => setCliente({...cliente, whatsapp: e.target.value})} placeholder="WhatsApp" className="px-3 py-2.5 rounded-xl border border-neutral-200 text-sm"/>
          {tipo === "delivery" && <input value={cliente.endereco} onChange={e => setCliente({...cliente, endereco: e.target.value})} placeholder="Endereço" className="md:col-span-3 px-3 py-2.5 rounded-xl border border-neutral-200 text-sm"/>}
        </div>
      </div>

      <div className="grid lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 bg-white rounded-2xl border border-neutral-200 p-4">
          <div className="flex items-center gap-2 border border-neutral-200 rounded-xl px-3 py-2 mb-4">
            <Search className="w-4 h-4 text-neutral-400"/>
            <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar produto..." className="flex-1 outline-none text-sm"/>
          </div>
          {filtrados.length === 0 && <p className="text-sm text-neutral-500 text-center py-8">Nenhum produto encontrado. Cadastre em "Produtos".</p>}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {filtrados.map(p => (
              <button key={p.id} onClick={() => add(p)} className="text-left bg-neutral-50 hover:bg-neutral-100 rounded-xl p-3 border border-neutral-200" data-testid={`vaipede-prod-${p.id}`}>
                {p.foto_url ? (
                  <img src={p.foto_url} alt="" className="w-full h-20 object-cover rounded-lg"/>
                ) : (
                  <div className="w-full h-20 rounded-lg bg-neutral-100 grid place-items-center text-neutral-300">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Z"/></svg>
                  </div>
                )}
                <div className="font-bold text-sm mt-1">{p.nome}</div>
                <div className="text-[#EA1D2C] font-black text-sm">{money(p.preco)}</div>
              </button>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-2xl border border-neutral-200 p-4">
          <h2 className="font-bold mb-3">Comanda</h2>
          {carrinho.length === 0 && <p className="text-sm text-neutral-500">Nenhum item adicionado.</p>}
          <div className="space-y-2 max-h-64 overflow-auto">
            {carrinho.map(x => (
              <div key={x.produto_id} className="flex items-center gap-2 py-2 border-b border-neutral-100">
                <div className="flex-1 min-w-0">
                  <div className="font-semibold text-sm truncate">{x.nome}</div>
                  <div className="text-xs text-neutral-500">{money(x.preco)} × {x.quantidade}</div>
                </div>
                <button onClick={() => dec(x.produto_id)} className="p-1 rounded bg-neutral-100"><Minus className="w-3 h-3"/></button>
                <span className="w-6 text-center text-sm font-bold">{x.quantidade}</span>
                <button onClick={() => add({ id: x.produto_id, nome: x.nome, preco: x.preco, categoria: x.categoria, foto_url: x.foto_url })} className="p-1 rounded bg-neutral-100"><Plus className="w-3 h-3"/></button>
                <button onClick={() => rem(x.produto_id)} className="p-1 text-red-500"><Trash2 className="w-3 h-3"/></button>
              </div>
            ))}
          </div>
          <textarea value={obs} onChange={e => setObs(e.target.value)} placeholder="Observações" className="w-full mt-3 px-3 py-2 rounded-xl border border-neutral-200 text-sm resize-none" rows={2}/>
          <div className="flex items-center justify-between mt-3 text-lg">
            <b>Total</b>
            <b className="text-[#EA1D2C]">{money(total)}</b>
          </div>
          {tipo !== "balcao" && (
            <button onClick={enviarCozinha} disabled={loading} className="w-full mt-3 py-3 rounded-xl bg-neutral-900 text-white font-bold text-sm disabled:opacity-60" data-testid="vaipede-btn-enviar">
              Enviar para cozinha
            </button>
          )}
          <button onClick={abrirConfirmarPagto} disabled={loading} className="w-full mt-2 py-3 rounded-xl bg-[#EA1D2C] text-white font-bold text-sm disabled:opacity-60 flex items-center justify-center gap-2" data-testid="vaipede-btn-confirmar-pagto">
            <CreditCard className="w-4 h-4"/> {tipo === "balcao" ? "Cobrar e enviar para cozinha" : "Confirmar pagamento"}
          </button>
          {tipo === "balcao" && (
            <p className="text-[11px] text-neutral-500 mt-2 text-center">
              Pedidos de balcão exigem pagamento imediato antes de irem para a cozinha.
            </p>
          )}
        </div>
      </div>

      {showPagto && (
        <PagamentoModal total={total} onClose={() => setShowPagto(false)} onFechar={async (pagamentos, forma) => {
          // Pedido pago já vai direto para a COZINHA (não é finalizado). O caixa é registrado
          // automaticamente no backend por conta do array `pagamentos` preenchido.
          const p = await criarPedido("preparando", forma, { pagamentos });
          if (!p) return;
          setCarrinho([]); setObs("");
          setShowPagto(false);
          toast.success("Pedido enviado para a cozinha", { description: "Pagamento registrado no caixa" });
          // Auto-abre o PDF quitado (QUITADO watermark aparece automaticamente por conta do status finalizado no PDF)
          downloadPdf(`/vaipede/pedidos/${p.id}/recibo-termico`, `pedido-${p.numero}.pdf`)
            .catch(() => {});
        }}/>
      )}
      {showComandas && <ComandasDia onClose={() => setShowComandas(false)}/>}
    </div>
  );
}

function PagamentoModal({ total, onClose, onFechar }) {
  const [pagamentos, setPagamentos] = useState([{ forma: "dinheiro", valor: "" }]);
  const [loading, setLoading] = useState(false);

  const totalPago = pagamentos.reduce((s, p) => s + Number(p.valor || 0), 0);
  const troco = Math.max(0, totalPago - total);
  const faltando = Math.max(0, total - totalPago);

  const addLinha = () => setPagamentos(ps => [...ps, { forma: "dinheiro", valor: "" }]);
  const rmLinha = (i) => setPagamentos(ps => ps.filter((_, idx) => idx !== i));
  const setLinha = (i, k, v) => setPagamentos(ps => ps.map((p, idx) => idx === i ? { ...p, [k]: v } : p));

  const preencherRestante = (i) => {
    const rest = total - pagamentos.reduce((s, p, idx) => idx === i ? s : s + Number(p.valor || 0), 0);
    if (rest > 0) setLinha(i, "valor", rest.toFixed(2));
  };

  const confirmar = async () => {
    if (totalPago < total - 0.01) { toast.error(`Faltam ${money(faltando)} para completar o pagamento`); return; }
    setLoading(true);
    const pagList = pagamentos.filter(p => Number(p.valor || 0) > 0).map(p => ({ forma: p.forma, valor: Number(p.valor) }));
    const formaPrincipal = pagList[0]?.forma || "dinheiro";
    await onFechar(pagList, formaPrincipal);
    setLoading(false);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/50 grid place-items-center p-4" onClick={onClose}>
      <div onClick={e => e.stopPropagation()} className="bg-white rounded-2xl w-full max-w-md p-5 max-h-[95vh] overflow-auto">
        <div className="flex items-center justify-between mb-1">
          <h2 className="font-black">Confirmar pagamento</h2>
          <button onClick={onClose} data-testid="vaipede-pagto-close"><X className="w-5 h-5"/></button>
        </div>
        <p className="text-xs text-neutral-500 mb-3">Divida o pagamento em quantas formas quiser.</p>

        <div className="text-center mb-4 py-3 bg-neutral-50 rounded-xl">
          <div className="text-xs text-neutral-500">Total</div>
          <div className="text-3xl font-black text-[#EA1D2C]">{money(total)}</div>
        </div>

        <div className="space-y-2 mb-3">
          {pagamentos.map((p, i) => (
            <div key={i} className="flex gap-2 items-center" data-testid={`vaipede-pagto-linha-${i}`}>
              <select value={p.forma} onChange={e => setLinha(i, "forma", e.target.value)} className="px-2 py-2 rounded-xl border border-neutral-200 text-sm" data-testid={`vaipede-pagto-forma-${i}`}>
                <option value="dinheiro">💵 Dinheiro</option>
                <option value="pix">📱 Pix</option>
                <option value="cartao_credito">💳 Crédito</option>
                <option value="cartao_debito">💳 Débito</option>
                <option value="maquininha">🏪 Máquina física</option>
              </select>
              <input type="number" step="0.01" value={p.valor} onChange={e => setLinha(i, "valor", e.target.value)}
                onBlur={e => { if (!e.target.value) preencherRestante(i); }}
                placeholder="R$ 0,00" className="flex-1 px-3 py-2 rounded-xl border border-neutral-200 text-sm" data-testid={`vaipede-pagto-valor-${i}`}/>
              {pagamentos.length > 1 && <button onClick={() => rmLinha(i)} className="p-2 text-red-500" data-testid={`vaipede-pagto-rm-${i}`}><Trash2 className="w-4 h-4"/></button>}
            </div>
          ))}
          <button onClick={addLinha} className="w-full py-2 rounded-xl border-2 border-dashed border-neutral-300 text-neutral-600 text-sm font-bold flex items-center justify-center gap-1" data-testid="vaipede-pagto-add">
            <Plus className="w-4 h-4"/> Adicionar forma de pagamento
          </button>
        </div>

        <div className="bg-neutral-50 rounded-xl p-3 mb-3 text-sm space-y-1">
          <div className="flex items-center justify-between"><span>Total pago</span><b>{money(totalPago)}</b></div>
          {faltando > 0 && <div className="flex items-center justify-between text-red-600 font-bold"><span>Faltando</span><span>{money(faltando)}</span></div>}
          {troco > 0 && (
            <div className="mt-2 p-3 rounded-xl bg-amber-50 border-2 border-amber-300 text-center" data-testid="vaipede-troco-destaque">
              <div className="text-xs text-amber-800 font-bold">TROCO A DEVOLVER</div>
              <div className="text-2xl font-black text-amber-700">{money(troco)}</div>
            </div>
          )}
        </div>

        <button onClick={confirmar} disabled={loading || faltando > 0} className="w-full py-3.5 rounded-xl bg-emerald-600 text-white font-black disabled:opacity-60" data-testid="vaipede-pagto-confirmar">
          {loading ? "Fechando..." : "Confirmar e finalizar"}
        </button>
      </div>
    </div>
  );
}

function ComandasDia({ onClose }) {
  const [rows, setRows] = useState([]);
  const [detalhe, setDetalhe] = useState(null);
  const load = () => vpAxios.get("/vaipede/pedidos/hoje").then(r => setRows(r.data));
  useEffect(() => { load(); }, []);

  const imprimir = (id, numero) => {
    downloadPdf(`/vaipede/pedidos/${id}/recibo-termico`, `comanda-${numero || id}.pdf`)
      .catch(() => toast.error("Erro ao gerar PDF"));
  };

  const validos = rows.filter(r => !["rejeitado","cancelado","pendente_pagamento"].includes(r.status));
  const totalDia = validos.reduce((s, r) => s + (r.total || 0), 0);
  // Agrupamento por forma
  const porForma = {};
  validos.forEach(p => {
    const f = (p.forma_pagamento || "outros").toLowerCase();
    porForma[f] = porForma[f] || { count: 0, total: 0 };
    porForma[f].count += 1;
    porForma[f].total += p.total || 0;
  });

  return (
    <div className="fixed inset-0 z-50 bg-black/50 grid place-items-center p-4" onClick={onClose}>
      <div onClick={e => e.stopPropagation()} className="bg-white rounded-2xl w-full max-w-3xl p-5 max-h-[95vh] flex flex-col">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h2 className="font-black text-lg">Comandas do dia</h2>
            <p className="text-xs text-neutral-500">{rows.length} pedidos · Total {money(totalDia)}</p>
          </div>
          <button onClick={onClose}><X className="w-5 h-5"/></button>
        </div>

        {/* Resumo por forma de pagamento */}
        {Object.keys(porForma).length > 0 && (
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-2 mb-4">
            {Object.entries(porForma).map(([f, d]) => (
              <div key={f} className="bg-neutral-50 rounded-xl p-3">
                <div className="text-xs text-neutral-500 capitalize">{f.replace(/_/g, " ")}</div>
                <div className="font-black text-sm">{money(d.total)}</div>
                <div className="text-xs text-neutral-500">{d.count} pedido{d.count > 1 ? "s" : ""}</div>
              </div>
            ))}
          </div>
        )}

        <div className="flex-1 overflow-auto">
          {rows.length === 0 && <p className="text-center text-neutral-500 py-8">Nenhum pedido hoje.</p>}
          <div className="divide-y divide-neutral-100">
            {rows.map(p => (
              <div key={p.id} className="py-3 flex items-center gap-3 text-sm relative">
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <b>#{p.numero}</b> · {p.cliente_nome || p.tipo}
                    {p.status === "finalizado" && (
                      <span className="inline-flex items-center gap-1 bg-emerald-100 text-emerald-700 text-[10px] font-black px-2 py-0.5 rounded-full border border-emerald-300" data-testid={`vaipede-selo-quitado-${p.id}`}>
                        ✓ QUITADO
                      </span>
                    )}
                  </div>
                  <div className="text-xs text-neutral-500">
                    {new Date(p.created_at).toLocaleTimeString("pt-BR")} · {(p.itens || []).length} itens · <span className="capitalize">{p.status}</span> · {p.forma_pagamento || "—"}
                  </div>
                </div>
                <div className="text-[#EA1D2C] font-black">{money(p.total)}</div>
                <button onClick={() => setDetalhe(p)} className="p-2 rounded-lg bg-blue-50 text-blue-700" title="Ver detalhes" data-testid={`vaipede-ver-ped-${p.id}`}>
                  <Eye className="w-4 h-4"/>
                </button>
                <button onClick={() => imprimir(p.id, p.numero)} className="p-2 rounded-lg bg-neutral-100" data-testid={`vaipede-imp-ped-${p.id}`}>
                  <Printer className="w-4 h-4"/>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
      {detalhe && <DetalhePedido pedido={detalhe} onClose={() => setDetalhe(null)} onImprimir={() => imprimir(detalhe.id, detalhe.numero)}/>}
    </div>
  );
}

function DetalhePedido({ pedido, onClose, onImprimir }) {
  const p = pedido;
  return (
    <div className="fixed inset-0 z-[60] bg-black/60 grid place-items-center p-4" onClick={onClose}>
      <div onClick={e => e.stopPropagation()} className="bg-white rounded-2xl w-full max-w-md p-5 max-h-[90vh] overflow-auto">
        <div className="flex items-center justify-between mb-3">
          <h2 className="font-black">Pedido #{p.numero}</h2>
          <button onClick={onClose}><X className="w-5 h-5"/></button>
        </div>
        <div className="text-xs text-neutral-500 mb-3">
          {new Date(p.created_at).toLocaleString("pt-BR")} · <span className="capitalize">{p.status}</span>
        </div>
        <div className="text-sm mb-3">
          <div><b>Cliente:</b> {p.cliente_nome || "—"}</div>
          {p.cliente_whatsapp && <div><b>WhatsApp:</b> {p.cliente_whatsapp}</div>}
          {p.endereco && <div><b>Endereço:</b> {p.endereco}</div>}
          {p.referencia && <div><b>Referência:</b> {p.referencia}</div>}
          <div><b>Tipo:</b> {p.tipo}{p.mesa_numero ? ` · Mesa ${p.mesa_numero}` : ""}</div>
          <div><b>Forma pagamento:</b> {p.forma_pagamento || "—"}</div>
          {p.troco_para && <div className="text-amber-700 font-bold"><b>Troco para:</b> {money(p.troco_para)} → devolver {money(p.troco_para - p.total)}</div>}
        </div>
        <div className="border border-neutral-200 rounded-xl p-3 mb-3">
          <b className="text-sm">Itens</b>
          <div className="mt-2 space-y-1 text-sm">
            {(p.itens || []).map((it, i) => (
              <div key={i} className="flex justify-between">
                <span>{it.quantidade}x {it.nome}</span>
                <span>{money(it.preco * it.quantidade)}</span>
              </div>
            ))}
          </div>
        </div>
        {p.observacao && <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-2 text-xs mb-3">📝 {p.observacao}</div>}

        {p.status === "finalizado" && (
          <div className="mb-3 flex items-center justify-center">
            <div className="border-4 border-emerald-600 text-emerald-700 font-black text-2xl px-6 py-2 rounded-xl transform -rotate-6 tracking-widest" data-testid={`vaipede-selo-detalhe-${p.id}`}>
              ✓ QUITADO
            </div>
          </div>
        )}

        {/* Discriminação de taxas globais (quando aplicáveis) */}
        {(Number(p.taxa_servico_valor || p.comissao_valor || 0) > 0 || Number(p.taxa_couvert_valor || p.cover_valor || 0) > 0) && (
          <div className="border border-neutral-200 rounded-xl p-3 mb-3 space-y-1 text-sm">
            {Number(p.subtotal || 0) > 0 && (
              <div className="flex justify-between text-neutral-600">
                <span>Subtotal</span>
                <span data-testid={`vaipede-det-subtotal-${p.id}`}>{money(p.subtotal)}</span>
              </div>
            )}
            {Number(p.taxa_servico_valor || p.comissao_valor || 0) > 0 && (
              <div className="flex justify-between text-neutral-600">
                <span>
                  Taxa de serviço{(p.taxa_servico_pct || p.comissao_pct) ? ` (${p.taxa_servico_pct || p.comissao_pct}%)` : ""}
                </span>
                <span data-testid={`vaipede-det-servico-${p.id}`}>{money(p.taxa_servico_valor || p.comissao_valor)}</span>
              </div>
            )}
            {Number(p.taxa_couvert_valor || p.cover_valor || 0) > 0 && (
              <div className="flex justify-between text-neutral-600">
                <span>
                  Couvert{p.taxa_couvert_pct
                    ? ` (${p.taxa_couvert_pct}%)`
                    : (p.taxa_couvert_num_pessoas && p.taxa_couvert_unitario
                        ? ` (${p.taxa_couvert_num_pessoas}x ${money(p.taxa_couvert_unitario)})`
                        : "")}
                </span>
                <span data-testid={`vaipede-det-couvert-${p.id}`}>{money(p.taxa_couvert_valor || p.cover_valor)}</span>
              </div>
            )}
          </div>
        )}

        <div className="flex items-center justify-between mb-3 text-lg"><b>Total</b><b className="text-[#EA1D2C]">{money(p.total_final || p.total)}</b></div>

        {(p.pagamentos && p.pagamentos.length > 0) && (
          <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-3 mb-3 space-y-1 text-sm" data-testid={`vaipede-pgtos-${p.id}`}>
            <div className="text-xs font-black text-emerald-800 mb-1">Formas de pagamento</div>
            {p.pagamentos.map((pg, i) => (
              <div key={i} className="flex items-center justify-between">
                <span className="capitalize">{(pg.forma || "").replace(/_/g, " ")}</span>
                <b>{money(pg.valor)}</b>
              </div>
            ))}
            {p.troco && Number(p.troco) > 0 && (
              <div className="flex items-center justify-between pt-1 border-t border-emerald-200 text-emerald-800 font-black">
                <span>Troco</span><span>{money(p.troco)}</span>
              </div>
            )}
          </div>
        )}
        <button onClick={onImprimir} className="w-full py-3 rounded-xl bg-neutral-900 text-white font-bold text-sm flex items-center justify-center gap-2">
          <Printer className="w-4 h-4"/> Imprimir 80mm
        </button>
      </div>
    </div>
  );
}
